"use client";
import { jsxs as m, jsx as n } from "react/jsx-runtime";
import { COLOR_SEVERITY as y } from "../../constants/colorSeverity.js";
import { mergeRefs as g } from "../../helpers/mergeRefs.js";
import { focusOutline as x } from "../../styles/mixins/focusOutline.js";
import { square as l } from "../../styles/mixins/square.js";
import u from "../../../components/icon/Icon.js";
import { css as c } from "@emotion/react";
import t from "@emotion/styled";
import { COLORS as e } from "../../../tokens/colors/Colors.js";
import { MOTION_DURATIONS as $ } from "../../../tokens/motion-durations/MotionDurations.js";
import { SIZES as s } from "../../../tokens/sizes/Sizes.js";
import { forwardRef as C, useRef as R, useEffect as S } from "react";
const w = C(
  ({
    className: o,
    feSeverity: h,
    feSize: r = "md",
    indeterminate: p = !1,
    onChange: d,
    ...b
  }, k) => {
    const i = R(null);
    S(() => {
      i.current && (i.current.indeterminate = p);
    }, [p]);
    const I = g([k, i]);
    return /* @__PURE__ */ m(O, { className: o, "data-comp": "input-checkbox", feSize: r, children: [
      /* @__PURE__ */ n(
        v,
        {
          ...b,
          onChange: (a) => d && d(a, a.target.checked),
          ref: I,
          type: "checkbox"
        }
      ),
      /* @__PURE__ */ m(E, { feSeverity: h, children: [
        /* @__PURE__ */ n(T, { feColor: "white", feIcon: "minus", feSize: r === "sm" ? "sm" : "lg" }),
        /* @__PURE__ */ n(N, { feColor: "white", feIcon: "check", feSize: r === "sm" ? "sm" : "lg" })
      ] })
    ] });
  }
);
w.displayName = "InputCheckbox";
const O = t.div(
  ({ feSize: o }) => c`
		flex-shrink: 0; /* Prevents shrink when flex-child */
		position: relative;

		${o === "md" && l(s.s24)};
		${o === "sm" && l(s.s18)};
	`
), v = t.input`
	cursor: pointer;
	height: inherit;
	margin: 0;
	opacity: 0;
	position: absolute;
	width: inherit;

	&:disabled {
		cursor: not-allowed;
	}
`, E = t.div(
  ({ feSeverity: o }) => c`
		background-color: ${e.white};
		border: solid 1px ${o ? y[o].base : e.gray500};
		border-radius: ${s.s02};
		height: inherit;
		pointer-events: none;
		position: absolute;
		transition: background-color ${$.fast}ms;
		width: inherit;

		input:checked ~ &,
		input:indeterminate ~ & {
			background-color: ${e.brand};
			border: 0;
		}

		input:checked ~ & span:last-of-type {
			opacity: 1;
		}

		input:indeterminate:not(:checked) ~ & span:first-of-type {
			opacity: 1;
		}

		input:disabled ~ & {
			background-color: ${e.gray500};
			border: 0;
		}

		input:focus-visible ~ & {
			${x()}
		}
	`
), f = c`
	left: 50%;
	opacity: 0;
	position: absolute;
	top: 50%;
	transform: translate(-50%, -50%);
`, N = t(u)`
	${f}
`, T = t(u)`
	${f}
`;
export {
  w as default
};
